<template>
  <v-card
      :color="primary"
      height="50px"
      width="50px"
  >
    <div class="d-flex  align-end justify-end fill-height">
      <v-card
          :color="secondary"
          height="15px"
          style="margin-right: 3px;margin-bottom: 3px;"
          width="15px"
      />
    </div>
  </v-card>
</template>

<script>
import config from "@/const";

export default {
  name: "ThemeItem",
  props: ['theme'],
  data: function () {
    return {
      primary: config.THEME_COLORS[this.theme].primary,
      secondary: config.THEME_COLORS[this.theme].secondary
    }
  }

}
</script>

<style scoped>

</style>